// extracted by mini-css-extract-plugin
export default {"wrapper":"Nq-z","response":"Oq-z","error":"Pq-z","disabled":"Qq-z","buttons":"Rq-z","feedbackQuestionSection":"Sq-z","yesNoWrapper":"Tq-z"};